/**
 * Perfiles que se muestran en los dual-list de usuarios de
 * `users-actions.component.ts` (loadMoreUsers / loadMoreUsers2).
 *
 * Antes estas listas estaban hardcodeadas y duplicadas dentro del
 * componente. Ver también los equivalentes en `+agenda`, `+agenda-user`
 * y `agendaSupervisor` (`agenda-profiles.util.ts`), que usan sus propias
 * listas porque no coinciden exactamente con estas.
 */

/** loadMoreUsers -> filtro por profileName. */
export const PERFILES_ASIGNABLES_USERS_ACTIONS: string[] = [
  'Operaciones migración',
  'Agente Operaciones',
  'Operaciones Auditor JR',
];

/** loadMoreUsers2 -> filtro por profileId. */
export const PROFILE_IDS_ASIGNABLES_USERS_ACTIONS: number[] = [
  134, 27, 94, 30, 63, 64, 34, 92, 88, 130, 103, 175, 178, 156
];
